const HOME = {
  WEBSITES_LIST_TITLE: "شما به وب‌سایت های زیر دسترسی دارید",
  NO_WEBSITES_ADDED_TITLE: "شما هنوز وب سایتی اضافه نکردین",
  ADD_NEW_WEBSITE: "افزودن وب سایت جدید",
  WELCOME: "خوش آمدید",
};

export default HOME;
